module.exports = __webpack_public_path__ + "static/media/03.146cd884.jpg";